/**
 * @generated SignedSource<<cc76f7be13cfddaddb707ddb49a5a00c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rowsAdditionalContentRenderer_nativeIssueTable$data = {
  readonly " $fragmentSpreads": FragmentRefs<"timelineRowsContent_issueTableTimeline">;
  readonly " $fragmentType": "rowsAdditionalContentRenderer_nativeIssueTable";
};
export type rowsAdditionalContentRenderer_nativeIssueTable$key = {
  readonly " $data"?: rowsAdditionalContentRenderer_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"rowsAdditionalContentRenderer_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "rowsAdditionalContentRenderer_nativeIssueTable",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "timelineRowsContent_issueTableTimeline"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "14936a88ab68218d38d76e038e65c173";

export default node;
